/**
 * Mueve el nodo del ghost shirt (design-preview-component) entre
 * .product-information__media y justo antes de Add to Cart según el ancho
 * de pantalla — en la página real de producto .media y .product-details ya
 * son 2 contenedores separados de fábrica (order: 0 / order: 1 en
 * blocks/_product-details.liquid), por eso el ghost shirt aparece primero
 * en mobile hoy. Mismo patrón que assets/product-configurator-layout.js
 * (guard antes de mover — insertBefore/after es una mutación real del DOM
 * incluso cuando el destino es el mismo, y algunas versiones de WebKit
 * dejan layouts de flex/grid cercanos con tamaños "stale" hasta el próximo
 * evento que fuerce un reflow), pero en un archivo separado porque los
 * selectores y la estructura del DOM no tienen nada en común con el
 * configurador — mezclarlos en un solo archivo haría que un cambio pensado
 * para una página pudiera romper la otra sin querer.
 *
 * Mueve el mismo nodo del DOM (no clona ni re-renderiza), así que
 * design-preview.js no pierde su estado ni sus listeners.
 *
 * Se carga sin type="module" a propósito: el script tag ya está posicionado
 * en el HTML justo después del grid de product-information, así que un
 * script clásico (sin module/defer/async) ejecuta de forma síncrona ahí
 * mismo, moviendo el DOM antes de que el navegador pinte la sección — un
 * module script es diferido por spec y dejaba pintar el layout inicial
 * (con el ghost shirt sin mover) antes de correr, causando el flash de
 * Size/Shirt color estirados en WebKit/iOS hasta el próximo reflow. Todo el
 * archivo va envuelto en un IIFE para no declarar nada en el scope global,
 * igual que el script equivalente en layout/theme.liquid.
 */
(function () {
  const DESKTOP_QUERY = '(min-width: 750px)';

  function reposition(mediaEl, previewEl, buyButtonsEl, desktopQuery) {
    if (desktopQuery.matches) {
      if (previewEl.parentElement !== mediaEl) {
        mediaEl.append(previewEl);
      }
    } else if (previewEl.nextElementSibling !== buyButtonsEl) {
      buyButtonsEl.before(previewEl);
    }
  }

  function initProductDetails(gridEl) {
    const mediaEl = gridEl.querySelector('.product-information__media');
    const previewEl = gridEl.querySelector("[id$='__media-gallery']");
    const buyButtonsEl = gridEl.querySelector("[class*='__buy_buttons_eYQEYi']");
    if (!mediaEl || !previewEl || !buyButtonsEl) return;

    const desktopQuery = window.matchMedia(DESKTOP_QUERY);
    reposition(mediaEl, previewEl, buyButtonsEl, desktopQuery);
    desktopQuery.addEventListener('change', () => reposition(mediaEl, previewEl, buyButtonsEl, desktopQuery));
  }

  document.querySelectorAll('.product-information__grid').forEach(initProductDetails);
})();
